import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorAnnouncements = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      d="M6 11.75a.75.75 0 0 0 0 1.5h12a.75.75 0 0 0 0-1.5H6Zm0 4a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5H6Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M13.485 2.713a1.5 1.5 0 1 0-2.97 0L4.74 7.25H4.5A2.25 2.25 0 0 0 2.25 9.5v10a2.25 2.25 0 0 0 2.25 2.25h15a2.25 2.25 0 0 0 2.25-2.25v-10a2.25 2.25 0 0 0-2.25-2.25h-.24l-5.775-4.537Zm-2.044 1.18a1.497 1.497 0 0 0 1.117 0l4.273 3.357H7.168l4.273-3.357ZM4.5 8.75h15a.75.75 0 0 1 .75.75v10a.75.75 0 0 1-.75.75h-15a.75.75 0 0 1-.75-.75v-10a.75.75 0 0 1 .75-.75Z"
    />
  </svg>
);
export default SvgTwoColorAnnouncements;
